export class OrganizationStep2FormResultKeys {
    static readonly FIRST_NAME = 'form_organization_step_2_field_first_name';
    static readonly LAST_NAME = 'form_organization_step_2_field_last_name';
    static readonly LNG = 'form_organization_step_2_field_correspondence_lang';
}

export interface IOrganizationStep2FormResultModel {
    form_organization_step_2_field_first_name: string;
    form_organization_step_2_field_last_name: string;
    form_organization_step_2_field_correspondence_lang: boolean;
}
